import { useState, useEffect } from 'react';

interface INetworkStatus {
  isOnline: boolean;
  isOffline: boolean;
  isSlowConnection: boolean;
}

export const useNetworkStatus = (): INetworkStatus => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const [isSlowConnection, setIsSlowConnection] = useState<boolean>(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    const checkConnectionSpeed = () => {
      const connection =
        (navigator as any).connection ||
        (navigator as any).mozConnection ||
        (navigator as any).webkitConnection;
      if (connection) {
        const slowTypes = ['slow-2g', '2g', '3g'];
        setIsSlowConnection(
          slowTypes.includes(connection.effectiveType) ||
            connection.downlink < 1,
        );
      } else {
        setIsSlowConnection(false);
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    checkConnectionSpeed();
    const intervalId = setInterval(checkConnectionSpeed, 5000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(intervalId);
    };
  }, []);

  return {
    isOnline,
    isOffline: !isOnline,
    isSlowConnection,
  };
};
